export default __webpack_public_path__ + "static/media/mic.99140867.jpg";